import { Component } from "@angular/core";
import { CTableCell } from "../../../../core/ui/c-table/c-table-config";
import { toUrlFriendlySlug } from "src/app/shared/utils/url-slug.util";
import { DIGITAL_MEMORY_LOG_CONSTANTS } from "../../constants/digital-memory-log.constants";
import { isDigitalMemoryLogExpired } from "../../utils/digital-memory-log.utils";

@Component({
  selector: "app-digital-memory-log-list-copy-link-component",
  template: `
    <div
      style="display: flex; align-items: center; width: 100%;"
      [title]="isExpired(row.entity) ? expiredTooltip : ''"
    >
      <span>
        <img
          (click)="onCopyClick(row.entity)"
          src="assets/icons/li_copy.svg"
          alt="Copy Link Icon"
          style="width: 20px; height: 20px; margin-right: 10px; flex-shrink: 0; opacity: 1; cursor: pointer;"
        />
      </span>
      <span
        style="flex: 1; font-size: 12px; color: #666; overflow: hidden; text-overflow: ellipsis; white-space: nowrap;"
      >
        {{ window.location.origin }}/preview-{{ getUrlFriendlyName(row.entity.name) }}-{{
          row.entity.id || "undefined"
        }}
      </span>
    </div>
  `,
})
export class CopyLinkColComponent implements CTableCell {
  extraData;
  row;
  column;
  window = window;
  readonly expiredTooltip = DIGITAL_MEMORY_LOG_CONSTANTS.MESSAGES.EXPIRED_TOOLTIP;

  getUrlFriendlyName(name: string): string {
    return toUrlFriendlySlug(name);
  }

  isExpired(entity: any): boolean {
    return isDigitalMemoryLogExpired(entity);
  }

  onCopyClick(entity: any): void {
    if (this.isExpired(entity)) {
      return;
    }

    this.extraData.copyLink(entity);
  }
}
